<template>
    <div>
        <modal :close="closeModal" :show="value">
            <template v-slot:header>
                <h1 class="header">There was an error submitting your application</h1>
            </template>

            <template v-slot:body>
                <div class="body-text">
                    <strong>{{ errorMessage }}</strong>
                </div>
            </template>

            <template v-slot:footer>
                <div class="text-right">
                    <button class="close-button" @click="closeModal(false)">Close</button>
                    <button class="okay-button" @click="closeModal(true)">Go back to payment methods</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"

    export default {
        name: "AcceptOfferErrorModal",
        components: {
            Modal,
        },
        props: {
            value: {
                type: Boolean,
                default: false,
            },

            errorMessage: {
                type: String,
                default: "",
            },
        },
        methods: {
            closeModal(confirm) {
                this.$emit("input", false)
                if (confirm === true) {
                    this.$emit("go-to-payment-methods")
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .header {
        padding-top: to_rem(24px);
        padding-bottom: to_rem(16px);
        font-style: normal;
        font-weight: 600;
        font-size: to_rem(26px);
        line-height: to_rem(32px);
        letter-spacing: -0.5px;
        color: $primary-color;
    }

    .body-text {
        font-weight: 400;
        font-size: to_rem(18px);
        color: $grey-darken-2;
        line-height: to_rem(28px);
    }

    .okay-button {
        font-size: to_rem(18px);
        margin: 0px 8px;
        height: 20px;
        color: $secondary-color;
        font-weight: bold;
    }

    .close-button {
        font-size: to_rem(18px);
        margin: 0px 20px;
        height: 20px;
        font-weight: bold;
    }
</style>
